/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteListItemDto } from '../../models/utente-list-item-dto';

export interface ApiAuthUtenteAdministratorListGet$Params {}

export function apiAuthUtenteAdministratorListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAuthUtenteAdministratorListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<UtenteListItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteAdministratorListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<UtenteListItemDto>>;
        }),
    );
}

apiAuthUtenteAdministratorListGet.PATH = '/api/auth/utente-administrator-list';
